module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "content login-wrapper"
  }, [_c('div', {
    staticClass: "content-inner loginBox"
  }, [_c('div', {
    staticClass: "flex-column full-w centered"
  }, [_c('div', {
    staticClass: "min-width-300 max-width-300"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/kundan-logo.png"),
      "width": "150px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("\n                " + _vm._s(_vm.isSms ? _vm.$t('static.smsTwoFactorVerification.title') : _vm.$t('static.googleTwoFactorVerification.title')) + "\n              ")]), _vm._v(" "), (_vm.isSms) ? _c('span', {
    staticClass: "display-block mobile-number-message"
  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.verificationCodeSent')) + ": "), _c('b', [_vm._v(_vm._s(_vm.mobileNumber))])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    attrs: {
      "btn-text": "button.login",
      "form": _vm.form,
      "translation": "form.twoFactorVerification"
    }
  }), _vm._v(" "), (_vm.isSms) ? _c('el-button', {
    staticClass: "dark",
    staticStyle: {
      "padding": "15px 20px"
    },
    attrs: {
      "loading": _vm.resendLoading,
      "disabled": _vm.twoFactorTimerCount > 0
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.twoFactorVerification.resendButton.label')) + " "), (_vm.twoFactorTimerCount) ? _c('span', [_vm._v("(" + _vm._s(_vm.twoFactorTimerCount || '') + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.verify
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('form.twoFactorVerification.verifyButton.label')) + "\n              ")])], 1)])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0d3e114","hasScoped":false}!./src/app/pages/auth/twoFactorVerification/twoFactorVerification.html
// module id = 3118
// module chunks = 1